import requests from "./httpService";

const WithdrawServices = {
    getAllWithdraw : async () =>{
        return requests.get(`/withdraw/`);
    },

    getWithdraw : async (id) =>{
        return requests.get(`/withdraw/${id}`);
    },
    updateWithdraw : async (id,body) =>{

        return requests.patch(`/withdraw/${id}`,body);
    },
   

}

export default WithdrawServices;